/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSurveyEmailContentDto
 */
export interface GetSurveyEmailContentDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmailContentDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmailContentDto
     */
    emailSubjectEn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmailContentDto
     */
    emailBody?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyEmailContentDto
     */
    emailBodyEn?: string | null;
}

/**
 * Check if a given object implements the GetSurveyEmailContentDto interface.
 */
export function instanceOfGetSurveyEmailContentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetSurveyEmailContentDtoFromJSON(json: any): GetSurveyEmailContentDto {
    return GetSurveyEmailContentDtoFromJSONTyped(json, false);
}

export function GetSurveyEmailContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyEmailContentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'emailSubjectEn': !exists(json, 'emailSubjectEn') ? undefined : json['emailSubjectEn'],
        'emailBody': !exists(json, 'emailBody') ? undefined : json['emailBody'],
        'emailBodyEn': !exists(json, 'emailBodyEn') ? undefined : json['emailBodyEn'],
    };
}

export function GetSurveyEmailContentDtoToJSON(value?: GetSurveyEmailContentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailSubject': value.emailSubject,
        'emailSubjectEn': value.emailSubjectEn,
        'emailBody': value.emailBody,
        'emailBodyEn': value.emailBodyEn,
    };
}

